import * as React from 'react';

// Whether sidebar filter wrappers render as collapsible <details> sections or
// plain always-open blocks. Chart-level (config.collapsibleFilters), provided
// by ChartLayout and read by FilterWrapper, so the many facet call sites don't
// each have to thread a prop.
export const FilterDisplayContext = React.createContext({ collapsible: false });
